import { Box, Link } from "@chakra-ui/react"

const HeaderLink = ({ children, noBorder, ...rest }) => {
	return (
		<Link
			color="#FDF6DC"
			fontSize="36px"
			fontFamily="PlayFairDisplayRegular"
			_hover={{
				textDecoration: 'none'
			}}
			_focus={{
				boxShadow: 'none'
			}}
			href="#"
			{...rest}
		>
			{children}
			{!noBorder ? (
				<Box mx="auto" width="30px" height="1px" bg="yellow.500" mt={4}></Box>
			) : null}
		</Link>
	)
}

export default HeaderLink
